import { render } from "./NotesView.vue?vue&type=template&id=be2db4e8&scoped=true&ts=true"
import script from "./NotesView.vue?vue&type=script&lang=ts"
export * from "./NotesView.vue?vue&type=script&lang=ts"

import "./NotesView.vue?vue&type=style&index=0&id=be2db4e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2db4e8"]])

export default __exports__